// Event statuses (events.event_status) and the Booking Closed lock: once an event is Booking Closed
// the event page's booking edits are locked until staff change the status back, typing CONFIRM.
// See docs/reference/BOOKING_CLOSED_LOCK.md.

export const BOOKING_CLOSED = 'Booking Closed'

export const EVENT_STATUS_OPTIONS = [
    { label: 'New', value: 'New', color: '#3988AA' },
    { label: 'Organiser Deposit Paid', value: 'Organiser Deposit Paid', color: '#FAAF3A' },
    { label: 'Invitees Deposit Paid', value: 'Invitees Deposit Paid', color: '#25BCED' },
    { label: 'Booking Closed', value: BOOKING_CLOSED, color: '#8B5CF6' },
    { label: 'Suppliers Fully Paid', value: 'Suppliers Fully Paid', color: '#679F54' },
    { label: 'Event Cancelled', value: 'Event Cancelled', color: 'red' },
]

export function eventStatusColor(status) {
    const option = EVENT_STATUS_OPTIONS.find(item => item.value === status)
    return option ? option.color : '#3988AA'
}

export function isBookingClosed(event) {
    return !!event && event.event_status === BOOKING_CLOSED
}
